<template>
  <div
    class="-mx-12 mt-5 p-12 flex flex-col flex-wrap justify-between border-t border-purple-ap-t03"
  >
    <h2 class="font-semibold text-purple-ap-100">
      Driving Skills
    </h2>

    <div class="flex flex-row justify-center mt-5">
      <div class="text-center">
        <p>
          <strong>Has more than one year of driving experience?</strong>
        </p>
        <p>{{ aupair.experiencedDriver ? "Yes" : "No" }}</p>
      </div>
    </div>
    <div class="mt-5">
      <p>{{ aupair.drivingSkills }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FullDrivingSkills",
  props: {
    aupair: Object,
  },
};
</script>
